import { useTranslation } from "react-i18next";

import { STATIC_ASSETS_BASE_URL } from "@/shared/utils/constants";

import "./styles.css";

const PRINCIPLE_TILES = [
  { key: "purpose", colorVar: "--green-700" },
  { key: "values", colorVar: "--green-500" },
  { key: "teach", colorVar: "--orange-500" },
  { key: "research", colorVar: "--primary-800" },
  { key: "partner", colorVar: "--primary-700" },
  { key: "practice", colorVar: "--orange-1000" },
  { key: "share", colorVar: "--orange-800" },
] as const;

const BrandingPanel = () => {
  const { t } = useTranslation();

  return (
    <aside
      className="onboarding-branding-panel flex flex-col justify-center gap-500"
      aria-label={t("layouts.onboarding.labels.brandingPanel")}
    >
      <div className="flex flex-col gap-100">
        <h1 className="onboarding-branding-panel__title header-xl-medium">
          {t("layouts.onboarding.labels.welcomeTitle")}
        </h1>

        <p className="onboarding-branding-panel__description header-s-regular">
          {t("layouts.onboarding.labels.welcomeDescription")}
        </p>
      </div>

      <div className="onboarding-branding-panel__tiles" role="list">
        {PRINCIPLE_TILES.map((tile) => (
          <div
            key={tile.key}
            className="onboarding-branding-panel__tile flex flex-col items-center justify-center gap-200"
            role="listitem"
            style={{ backgroundColor: `var(${tile.colorVar})` }}
          >
            <img
              className="onboarding-branding-panel__tile-icon"
              src={`${STATIC_ASSETS_BASE_URL}/${tile.key}.svg`}
              alt=""
              aria-hidden="true"
            />
            <span className="onboarding-branding-panel__tile-label body-s-medium">
              {t(`layouts.onboarding.labels.principles.${tile.key}`)}
            </span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default BrandingPanel;
